var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcnMenu(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icn_menu") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Kapital_Presentation",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Backgroundstory_Initial_Mobile-360_PH_Version3.1",
    transform: "translate(-310.000000, -499.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icn_menu",
    transform: "translate(310.000000, 499.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(8.000000, 8.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.75,
    y: 0.75,
    width: 8.5,
    height: 8.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    x: 0.75,
    y: 14.75,
    width: 8.5,
    height: 8.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    x: 14.75,
    y: 0.75,
    width: 8.5,
    height: 8.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    x: 14.75,
    y: 14.75,
    width: 8.5,
    height: 8.5
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnMenu);
export default __webpack_public_path__ + "static/media/icn_menu.561bb7c10cc0263381c54c6567e38c5a.svg";
export { ForwardRef as ReactComponent };